<template>
    <div>{{ clubName }}</div>
</template>
<script setup lang="ts">
/**
 * This will display the club name based on the club ID
 */
import { useLoaders, useTaskLoader } from '@/composeables';
import { useCommonStoreRef } from '@/stores';
import { computed, watch } from 'vue';

const props = defineProps<{
    /**
     * The club ID to display
     */
    value: number | null;
}>();

const { AddLoader, LoadState } = useTaskLoader();
useLoaders(AddLoader, ['CLUBS']);

const { Clubs } = useCommonStoreRef();

/**
 * The name of the club to display
 */
const clubName = computed(() => {
    if (!props.value) return '';

    const club = Clubs.value.find((c) => c.ID === props.value);
    return club ? club.Name : '';
});
</script>
